import { COLORS } from '@btime/constants'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import FlexGrid from '../structure/FlexGrid'
import Icon from '../../packages/kiti/components/shapes/Icon'
import InputButton from './InputButton'
import Link from '../../packages/kiti/components/actions/Link'
import Modal from '../structure/Modal'
import Separator from '../../packages/kiti/components/helpers/Separator'
import Text from '../../packages/kiti/components/presentation/Text'

const DEFAULT_ICONS = [
  'RiAncientGateLine',
  'RiAncientPavilionFill',
  'RiBankLine',
  'RiBuilding2Line',
  'RiBuilding4Line',
  'RiBuildingLine',
  'RiCommunityLine',
  'RiHome2Line',
  'RiHomeHeartLine',
  'RiHospitalLine',
  'RiStore2Line',
  'RiArchiveLine',
  'RiBarChartBoxLine',
  'RiAwardLine',
  'RiAtLine',
  'RiBookmark3Line',
  'RiBriefcase4Line',
  'RiCalendarCheckLine',
  'RiCalendarLine',
  'RiCloudLine',
  'RiCreativeCommonsByLine',
  'RiCustomerService2Line',
  'RiFlagLine',
  'RiInboxLine',
  'RiInboxUnarchiveLine',
  'RiLineChartLine',
  'RiMailCheckLine',
  'RiMailLine',
  'RiMailSendLine',
  'RiPieChartLine',
  'RiPrinterLine',
  'RiReplyAllLine',
  'RiReplyLine',
  'RiSlideshow3Line',
  'RiSlideshowLine',
  'RiStackLine',
  'RiChat3Line',
  'RiChatCheckLine',
  'RiChatNewLine',
  'RiQuestionAnswerLine',
  'RiBallPenLine',
  'RiCollageLine',
  'RiCompasses2Line',
  'RiDragDropLine',
  'RiDropLine',
  'RiEdit2Line',
  'RiFocus3Line',
  'RiHammerLine',
  'RiPaletteLine',
  'RiPantoneLine',
  'RiPencilRulerLine',
  'RiBug2Line',
  'RiGitBranchLine',
  'RiGitRepositoryPrivateLine',
  'RiTerminalBoxLine',
  'RiBatteryChargeLine',
  'RiDashboard3Line',
  'RiDatabase2Line',
  'RiFingerprintLine',
  'RiPhoneLine',
  'RiQrCodeLine',
  'RiQrScan2Line',
  'RiRadarLine',
  'RiSave3Fill',
  'RiShutDownLine',
  'RiUsbLine',
  'RiClipboardLine',
  'RiDraftLine',
  'RiCurrencyLine',
  'RiGiftLine',
  'RiHandHeartLine',
  'RiRedPacketLine',
  'RiShoppingBasket2Line',
  'RiShoppingCart2Line',
  'RiTrophyLine',
  'RiVipCrown2Line',
  'RiHeart3Line',
  'RiHeartPulseLine',
  'RiFingerprintLine',
  'RiStethoscopeLine',
  'RiSyringeLine',
  'RiTestTubeLine',
  'RiCompass3Line',
  'RiBus2Line',
  'RiCarLine',
  'RiBikeLine',
  'RiEBike2Line',
  'RiFlightTakeoffFill',
  'RiMapPin2Line',
  'RiMotorbikeLine',
  'RiMapPinUserLine',
  'RiRocket2Line',
  'RiShipLine',
  'RiTruckLine',
  'RiImage2Line',
  'RiNotification2Line',
  'RiPolaroid2Line',
  'RiVidicon2Line',
  'RiLock2Line',
  'RiShieldKeyholeLine',
  'RiSpamLine',
  'RiTimerLine',
  'RiEmotionHappyLine',
  'RiEmotionUnhappyLine',
  'RiEmotionNormalLine',
  'RiGroup2Line',
  'RiTeamLine',
  'RiParentLine',
  'RiMoonClearLine',
  'RiMoonCloudyLine',
  'RiShowersFill',
  'RiSunCloudyLine',
  'RiSunFoggyLine',
  'RiThunderstormsLine',

  'RiAppleLine',
  'RiGoogleFill',
  'RiLinkedinBoxLine',
  'RiInstagramLine',
  'RiGithubFill',
  'RiNetflixFill',
  'RiPatreonFill',
  'RiPaypalLine',
  'RiPinterestFill',
  'RiRedditFill',
  'RiSpotifyLine',
  'RiTwitterLine',
  'RiWhatsappLine'

  // 'BsFillArchiveFill',
  // 'BsFillBellFill',
  // 'BsFillBrightnessHighFill',
  // 'BsFillChatDotsFill',
  // 'BsFillCollectionPlayFill',
  // 'BsFillGearFill',
  // 'BsFillGeoAltFill',
  // 'BsFillFlagFill',
  // 'BsFillImageFill',
  // 'BsFillInboxesFill',
  // 'BsFillReplyFill',
  // 'BsFillShieldLockFill',
  // 'BsArchiveFill',
  // 'BsBucket',
  // 'BsCompass',
  // 'BsConeStriped',
  // 'BsFileCheck',
  // 'BsFolderCheck',
  // 'BsImages',
  // 'BsPersonBoundingBox',
  // 'BsPower',
  // 'BsShieldShaded',
  // 'BsToggles',
  // 'BsWrench',

  // 'BsFillEnvelopeFill',
  // 'BsFillBarChartFill',
  // 'BsFillAwardFill',
  // 'BsFillExclamationSquareFill',
  // 'BsLayoutTextSidebarReverse',
  // 'BsFillFolderFill',
  // 'BsFillGearFill',
  // 'BsGeo',
  // 'BsFillGridFill',
  // 'BsListTask'
]

const IconPicker = ({ onChange, value }) => {
  const { t } = useTranslation('common')
  const [open, setOpen] = useState(false)

  const handleChange = value => {
    onChange(value)
    setOpen(false)
  }

  return (
    <>
      <InputButton
        value={(value ? t('edit') : t('selectOne')) + ' ' + t('icon')}
        iconLeft={value || 'BsThreeDots'}
        iconSize="1rem"
        onClick={() => setOpen(true)}
        iconColor={COLORS.purple}
      />

      <Modal open={open} onClose={() => setOpen(false)} width="32rem">
        <FlexGrid wrap justify="flex-start" gutter={0.35}>
          {DEFAULT_ICONS.map(icon => (
            <Link key={icon} onClick={() => handleChange(icon)}>
              <Icon name={icon} size={1.4} color={value === icon ? COLORS.purple : COLORS.dark4} />
            </Link>
          ))}
        </FlexGrid>
        <Separator weight={4} />
        {!!value && (
          <Link onClick={() => handleChange(null)}>
            <Text color={COLORS.red} size="small">
              {t('removeSelection')}
            </Text>
          </Link>
        )}
      </Modal>
    </>
  )
}

export default IconPicker
